import { writable } from "svelte/store";
import { type User, getMe } from "../api";
import { resetFilters } from "../filters";

export const currentUser = writable<User | null>(null);

// False until the initial /api/me has resolved. Route guards must wait for
// this before treating a null currentUser as "logged out" — otherwise the
// first synchronous store emission (null, before initAuth resolves) bounces
// an authenticated admin off admin pages on refresh/deep-link.
export const authReady = writable(false);

export async function initAuth(): Promise<void> {
  try {
    const user = await getMe();
    currentUser.set(user);
  } finally {
    authReady.set(true);
  }
}

// Called by the explicit sign-in flows (login, signup, reset, setup). Filters
// live in memory and outlive sign-out, so each new sign-in starts with none
// instead of the previous person's.
export function setUser(user: User): void {
  resetFilters();
  currentUser.set(user);
}

export function clearUser(): void {
  currentUser.set(null);
}
